export default __webpack_public_path__ + "static/tour_05_scaffolded-ce347c7c4a30b7a839cf56d8eb95778f.jpg";